import { policyTextForEditor, resolvePolicyDisplayHtml, sanitizeRichHtmlForDisplay } from './policyContentHtml';

export { policyTextForEditor, resolvePolicyDisplayHtml, sanitizeRichHtmlForDisplay };

/** Decode common HTML entities (including numeric) after tag stripping. */
export function decodeHtmlEntities(text: string): string {
  return text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&#(\d+);/g, (_, code: string) => String.fromCharCode(Number(code)))
    .replace(/&#x([0-9a-f]+);/gi, (_, hex: string) => String.fromCharCode(parseInt(hex, 16)));
}

/** Plain text length after stripping tags (for previews and validation). */
export function stripRichTextToPlain(html: string | null | undefined): string {
  if (!html) return '';
  const withoutTags = html.replace(/<[^>]+>/g, ' ');
  const decoded = decodeHtmlEntities(withoutTags);
  return decoded.replace(/\s+/g, ' ').trim();
}

export function isRichTextEmpty(html: string | null | undefined): boolean {
  return stripRichTextToPlain(html).length === 0;
}

/** HTML safe for listing description display (legacy plain text supported). */
export function resolveListingDescriptionHtml(description: string | null | undefined): string {
  const resolved = resolvePolicyDisplayHtml(description);
  return resolved ? sanitizeRichHtmlForDisplay(resolved) : '';
}

/** Value for Quill when editing an existing listing description. */
export function listingDescriptionForEditor(description: string | null | undefined): string {
  return policyTextForEditor(description);
}

/** Single-line plain excerpt for compact cards (never includes markup). */
export function listingDescriptionPlainExcerpt(
  description: string | null | undefined,
  maxLength = 160
): string {
  const plain = stripRichTextToPlain(description);
  if (!plain) return '';
  if (plain.length <= maxLength) return plain;
  const slice = plain.slice(0, maxLength);
  const lastSpace = slice.lastIndexOf(' ');
  const trimmed = (lastSpace > maxLength * 0.6 ? slice.slice(0, lastSpace) : slice).trim();
  return `${trimmed}…`;
}
